import React, { useEffect, useState } from 'react';
import Order from '@/model/Order';
import Page from '@/model/Page';
import { api } from '@/services/api';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoading } from '@/redux/loading/loadingSlice';
import { useSidebar } from '@/hooks/useSidebar';
import { SidebarProps } from '@/components/Sidebar';
import { TicketsOrder } from './ui';
import { TutorialApp } from '../../components/TutorialApp';

export const TicketsOrderScreen: React.FC = () => {
  const { onShowSidebar } = useSidebar();
  const [orders, setOrders] = useState<Page<Order, Order>>({} as Page<Order, Order>);
  const dispatch = useDispatch();
  const history = useNavigate();

  const getOrders = async (): Promise<void> => {
    dispatch(setLoading(true));
    const pageOrder: Page<Order, Order> = {
      page: 1,
      pageSize: 10,
      sort: 'orderDate',
      order: 'DESC',
    };
    const response = await api.post<Page<Order, Order>>('/client/order', pageOrder);
    setOrders(response.data);
    dispatch(setLoading(false));
  };

  const handleOnShowDetailTicket = (item: Order): void => {
    history(`/ingressos/detalhe/${item.id}`);
  };

  const handleTutotialApp = (): void => {
    onShowSidebar({
      content: <TutorialApp />,
      title: 'Visualizar ingresso',
    } as SidebarProps);
  };

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <TicketsOrder
      orders={orders}
      onShowDetailTicket={handleOnShowDetailTicket}
      onPressTutotialApp={handleTutotialApp}
    />
  );
};
